import { Component, Input, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { packageCardDetails } from 'src/app/gdo/gdo-shared/Models/Models';

@Component({
    selector: 'app-gdo-subscription-item',
    templateUrl: './gdo-subscription-item.component.html',
    styleUrls: ['./gdo-subscription-item.component.scss'],
    standalone: false
})
export class GdoSubscriptionItemComponent implements OnInit {
  @Input() subscription!: packageCardDetails;
  isExpired: boolean = false;
  packagePrice:any;
  isCurrentPlanCancelled: boolean = false;
  channel:any;
  mobile:any |boolean;
  isTrial = false;
  constructor(private service: AppService) {}

  ngOnInit(): void {
    this.isTrial= this.ifTial();
    this.mobile = this.service.getWebviewCurrentStatus();

    var packageEndDate = new Date(this.subscription?.subsExpiryDate ?? '');
    if (
      packageEndDate.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
    ) {
      this.isExpired = false;
    } else {
      this.isExpired = true;
    }
    let selectedSP = this.service.getSelectedSp();
    if (selectedSP && selectedSP.suppPlanInstanceStatus == 'Cancelled') {
      this.isCurrentPlanCancelled = true;
    } else {
      this.isCurrentPlanCancelled = false;
    }
    this.calculateAnnualPricePerMonth();
    this.setChannel();
  }

  setChannel(){
    let accountDetails= this.service.getAccDetails();
    let gdoVechileDetails = accountDetails.masterPlansInfo[0];
    if (gdoVechileDetails && gdoVechileDetails.mpPlanInstFields.length > 0) {
      for (const mp_iterator of gdoVechileDetails?.mpPlanInstFields) {
        if (mp_iterator.planInstanceFieldName === 'Make')
        {this.channel = mp_iterator.planInstanceFieldValue;}
      }
    }
  }

  getHeaderTitleColorClass(subscription: packageCardDetails) {
    if (subscription?.isCurrent) {
      return 'font-12 grey-color font-weight-500';
    }     
    else if (this.mobile){
      return 'font-12 text-sub-color-3 font-weight-700';
    }
    else {
      return 'font-12 text-sub-color-3 font-weight-500';
    }
  }

  getColorClass(subscription: packageCardDetails) {
    if (subscription?.isCurrent) {
      return 'font-12 grey-color font-weight-400';
    } 
    // else if (this.mobile){
    //   return 'font-12 text-sub-color-3 font-weight-700';
    // }
    else
    {
      return 'font-12 text-sub-color-3 font-weight-400';
    }
  }

  ifTial(){
    
    return this.subscription.duration =="Trial";
  }
  
  calculateAnnualPricePerMonth() {
      this.packagePrice = this.subscription?.packagePrice;
      if(this.packagePrice == 179){ //179 is the 5 year plan 
        this.packagePrice = (this.packagePrice / 60).toFixed(2);
      }else{

        this.packagePrice = (this.packagePrice / 36).toFixed(2);
      }
    }
}
